<template>
  <nav class="nav">
    <ul>
      <li>
        <router-link to="/">./home</router-link>
      </li>
      <li>
        <router-link to="/work">./work</router-link>
      </li>
      <li>
        <router-link to="/case-studies">./case-studies</router-link>
      </li>
      <li>
        <router-link to="/about">./about</router-link>
      </li>
      <li>
        <router-link to="/contact">./contact</router-link>
      </li>
      <li>
        <a href="https://github.com/Archezi" target="_blank"
          ><img src="@/assets/icons/github.svg" alt=""
        /></a>
      </li>
      <li>
        <a href="https://www.linkedin.com/in/lukaszkaczmarek35/" target="_blank"
          ><img src="@/assets/icons/linkedin.svg" alt=""
        /></a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {};
</script>

<style></style>
